import React from 'react';
import {
    Container,
    Grid,
    Typography,
    Paper,
    List,
    ListItem,
    ListItemText,
    ThemeProvider,
    createTheme,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from '@mui/material';
import { useAuth } from '../../Auth/AuthProvider';
// import { empresaDataAPI, representanteempresaShow } from '../../Conections/EmpresaConection';
import { useNavigate, useParams } from 'react-router-dom';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { RoleShowAPI } from '../../Conections/RolesAndPermissionsConection';
import ErrorCard from '../../Conections/ErrorCard';
import { can } from '../../Conections/LogConections';

// Creamos un tema personalizado
const theme = createTheme();

export default function ShowRole() {

    const auth = useAuth();
    const goTo = useNavigate();
    const idPlan = useParams();

    const [expanded, setExpanded] = React.useState(false);
    const [permission, setPermission] = React.useState(false);
    const [name, setName] = React.useState('');
    const [description, setDescription] = React.useState('');
    const [permitido, setPermitido] = React.useState(false);
    const [permitidoP, setPermitidoP] = React.useState(false);


    React.useEffect(() => {
        reloaduser();
    }, []);

    async function reloaduser() {
        if (auth.getToken()) {
            const permisionCan = await can(auth.getToken(), auth.getCompany(), "/dashboard/rpp/showrole/:id");
            setPermitidoP(permisionCan === 1);
            if (permisionCan === 1) {
                const role = await RoleShowAPI(auth.getToken(), auth.getCompany(), idPlan.id);
                if (typeof role[0] === "number") {
                    setPermitido(false);
                } else {
                    setPermitido(true);
                    setName(role.name);
                    setDescription(role.description);
                    var result = Object.keys(role.section).map((key) => [key, role.section[key]]);
                    setPermission(result);
                }
            }
            else{
                goTo("/dashboard");
            }
        }
        else {
            goTo(`/login`);
        }
    }

    const handleChangeA = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <ThemeProvider theme={theme}>

            {permitidoP && permitido ?
                (
                    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                        <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ mb: 4 }}>
                            Company and Representative Information
                        </Typography>

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Paper elevation={3} sx={{ p: 3 }}>
                                    <Typography variant="h5" component="h2" gutterBottom>
                                        Role Data
                                    </Typography>
                                    <List>
                                        <ListItem>
                                            <ListItemText primary="Name" secondary={name} />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemText primary="Nit" secondary={description} />
                                        </ListItem>
                                    </List>
                                </Paper>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Paper elevation={3} sx={{ p: 3 }}>
                                    <Typography variant="h5" component="h2" gutterBottom>
                                        Permission Data
                                    </Typography>
                                    {permission ?
                                        (
                                            permission.map((section, index) => (
                                                <Accordion expanded={expanded === index} onChange={handleChangeA(index)} key={index}>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls="panel1bh-content"
                                                        id="panel1bh-header"
                                                    >
                                                        <Typography sx={{ width: '33%', flexShrink: 0 }}>
                                                            {section[1].name}
                                                        </Typography>
                                                        <Typography sx={{ color: 'text.secondary' }}>
                                                            {section[1].section}
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <List>
                                                            {
                                                                Object.keys(section[1].per).map((key) => [key, section[1].per[key]])
                                                                    .map((permission, index) => (
                                                                        <ListItem key={index}>
                                                                            <Typography>
                                                                                {permission[1].name}
                                                                            </Typography>
                                                                        </ListItem>
                                                                    ))

                                                            }

                                                        </List>
                                                    </AccordionDetails>
                                                </Accordion>

                                            ))
                                        ) : (
                                            <List>
                                                <ListItem>
                                                    <Typography variant="h7" component="h2" gutterBottom>
                                                        Empty
                                                    </Typography>
                                                </ListItem>
                                            </List>
                                        )
                                    }
                                </Paper>
                            </Grid>
                        </Grid >
                    </Container >
                ) : (
                    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                        <ErrorCard></ErrorCard>
                    </Container >
                )
            }
        </ThemeProvider >
    );
}